module.exports = __webpack_public_path__ + "img/full2-min.0ff97b2a.png";